


































import Vue from "vue";
import Component from "vue-class-component";

import { Event } from "../../types";

const CardLimitProps = Vue.extend({
  props: {
    cardLimit: String
  }
});

@Component
export default class CardLimit extends CardLimitProps {
  noLimitString = "Currently no limit";
  defaultLabel = "Card Limit";
  showHelpText = false;

  get label() {
    return this.curCardLimit ? this.defaultLabel : this.noLimitString;
  }

  get curCardLimit() {
    return this.cardLimit === "0" || !this.cardLimit ? null : this.cardLimit;
  }

  set curCardLimit(newValue) {
    this.$eventHub.$emit(Event.UPDATE_CARD_LIMIT, newValue);
  }

  deactivatecardLimit() {
    this.$eventHub.$emit(Event.UPDATE_CARD_LIMIT, "0");
  }
}
